import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import bankidApi from 'services/bankid/bankid';

interface IVypisUvod {}

const VypisBankidLogin: React.FC<IVypisUvod> = () => {
    const history = useHistory();
    const { idzadosti } = useParams<{ idzadosti: string }>(); // idzadosti, sebrano z urlky pokud se v url vyskytuje pocitame s tim ze se uzivatel jiz prihlasil poprve a vraci se z odkazu na mailu.
    const [errStatus, setErrStatus] = useState<number>();

    const routeChange = () => {
        let path = idzadosti ? '/nezarazeny-ucet/bankid/' + idzadosti : '/nezarazeny-ucet/bankid';
        history.push(path);
    };

    const bankIdLogin = () => {
        bankidApi('INFO')
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((resp: any) => {
                window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID v new okne
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    const bankIdLoginZadost = () => {
        bankidApi('INFO', idzadosti)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((resp: any) => {
                window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID v new okne
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    return (
        <>
            {errStatus ? (
                <StatementWrapper pageTitle="">
                    <Col span={24}>
                        <Row>
                            {errStatus === 400 ? (
                                <Title text="RESPONSE_ERROR_400" level={3} />
                            ) : errStatus === 401 ? (
                                <Title text="RESPONSE_ERROR_401" level={3} />
                            ) : errStatus === 404 ? (
                                <Title text="RESPONSE_ERROR_404" level={3} />
                            ) : errStatus === 500 ? (
                                <Title text="RESPONSE_ERROR_500" level={3} />
                            ) : errStatus ? (
                                <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                            ) : null}
                        </Row>

                        <Row className="statement-buttons-row">
                            <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                        </Row>
                    </Col>
                </StatementWrapper>
            ) : (
                <>
                    {idzadosti ? (
                        <>
                            <h1>
                                <TranslateText>NEZARAZENY_UCET_PRIHLASENI</TranslateText>
                            </h1>
                            <StatementWrapper pageTitle="" pageInfoText="PRISTUP_K_DRIVE_PODANE_ZADOSTI">
                                <Row className="statement-buttons-row">
                                    <ButtonComponent
                                        buttontext="PRIHLASIT_SE_PPRES_BANKID"
                                        onClick={bankIdLoginZadost}
                                    />
                                </Row>
                            </StatementWrapper>
                        </>
                    ) : (
                        <>
                            <h1>
                                <TranslateText>POPIS_SLUZBY</TranslateText>
                            </h1>
                            <div>
                                <TranslateText>PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE_P1</TranslateText>
                                <span
                                    style={{
                                        fontWeight: 'bold'
                                    }}
                                >
                                    <TranslateText>PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE_P2</TranslateText>
                                </span>
                                <TranslateText>PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE_P3</TranslateText>
                            </div>
                            <StatementWrapper
                                pageTitle=""
                                pageInfoText=""
                                pageInfoTextBold="PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE2"
                                pageInfoTextBold2="PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE3"
                            >
                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="PRIHLASIT_SE_PPRES_BANKID" onClick={bankIdLogin} />
                                </Row>
                            </StatementWrapper>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default VypisBankidLogin;
